import { useContext } from 'react';
import { ServicesChartsDataContext } from '../contexts/ServicesChartsDataContext';

export const useServicesChartsDataContext = () => {
    return useContext(ServicesChartsDataContext);
};
